module.exports = __webpack_public_path__ + "img/ill_badge_profile_block_user.08c67739.svg";